<template>
  <div class="conceitos">
    <div class="mb-2" style="text-align: right">
      <v-btn color="cyan" width="90px" small dark to="/conceitos/novo" class="rounded-sm font-weight-regular" >Novo</v-btn>
    </div>
    <v-alert type="error" v-if="gruposConceito.length <= 0" value="true" dark class="mt-3 mb-3">
      <div>Nenhum grupo de conceito cadastrado!</div>
    </v-alert>
    <v-card v-else style="overflow-y: auto">
      <table class="table-siged">
        <thead>
          <tr>
            <th>Código</th>
            <th>Nível</th>
            <th>Ano de Cadastro</th>
            <th>Conceitos</th>
            <th>Em Uso</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="conceito in gruposConceito" :key="conceito.identificadorgrupoconceito">
            <td class="centro">{{ conceito.identificadorgrupoconceito }}</td>
            <td class="centro">{{ conceito.nivel.cdinstruc }} - {{ conceito.nivel.dsinstruc }}</td>
            <td class="centro">{{ conceito.ano }}</td>
            <td class="centro">
              <v-tooltip bottom style="flex: 1">
                <template v-slot:activator="{ on, attrs }">
                  <span v-bind="attrs" v-on="on" >{{ conceito.conceitos.length }}</span>
                </template>
                <span>
                  <div v-for="key in conceito.conceitos" :key="key.id">
                    <i><strong>{{ key.valorconceito }}</strong> - {{ key.descricaoconceito }}</i>
                  </div>
                </span>
              </v-tooltip>
            </td>
            <td class="centro">{{ conceito.indicauso === 'S' ? 'Sim' : 'Não' }}</td>
            <td class="centro">
              <v-btn icon title="Editar" class="aulas-btn-acao" :to="{ path: `/conceitos/${conceito.identificadorgrupoconceito}` }">
                <v-icon class="btn-acoes-icon">edit</v-icon>
              </v-btn>
              <v-btn icon title="Excluir" class="aulas-btn-acao" @click="excluir(conceito.identificadorgrupoconceito)">
                <v-icon color="red">delete_forever</v-icon>
              </v-btn>
            </td>
          </tr>
        </tbody>
      </table>
      <div v-if="quantidadePaginas > 1" class="table-siged-page" style="text-align: right">
        <v-pagination v-model="paginaAtual" :length="quantidadePaginas" total-visible="7" />
      </div>
    </v-card>
    <v-snackbar v-model="snackbar" bottom left :timeout="4000" height="10px" rounded="0"  >
        <div class="d-flex justify-space-between align-center">
           <span> {{ submitText }}</span>
            <v-btn class="text-right" variant="text"  icon  @click="snackbar = false" > <v-icon>close</v-icon> </v-btn>
        </div>
    </v-snackbar>
  </div>
</template>

<script>
import { RepositoryFactory } from '@/repositories/RepositoryFactory';

const ConceitosRepository = RepositoryFactory.get('conceitos');

export default {
  name: 'Conceitos',
  data() {
    return {
      gruposConceito: [],
      paginaAtual: 1,
      quantidadePaginas: 0,
      snackbar: false,
      submitText: '',
    };
  },
  watch: {
    paginaAtual() {
      this.reload();
    }
  },
  async beforeRouteEnter(to, from, next){
    const { data } = await ConceitosRepository.getListaGrupoConceitos();

    next(vm => vm.reload(data));
  },
  methods: {
    async reload(data = null) {
      if(!data) {
        this.$Progress.start();
        const retorno = await ConceitosRepository.getListaGrupoConceitos({ page: this.paginaAtual });
        data = retorno.data;
      }
      this.paginaAtual = data.results.current_page;
      this.gruposConceito = data.results.data;
      this.quantidadePaginas = data.results.last_page;

      this.$Progress.finish();
    },
    async excluir(id) {
      const confirmar = await this.$sgal({
        title: 'Tem certeza?',
        text: 'Deseja realmente excluir este grupo de conceito?',
        type: 'warning',
        buttons: [
          { text: 'Excluir', color: 'red', response: true },
          { text: 'Cancelar', color: 'grey', response: false },
        ],
      });
      if(!confirmar) { return; }

      try {
        const { data } = await ConceitosRepository.deleteGrupoConceitos(id);

        this.submitText = data.message;
        this.snackbar = true;
        if(this.paginaAtual > 1 && this.gruposConceito.length == 1) { this.paginaAtual--; }
        this.reload();
      }catch(error) {
        if(error.response) {
          this.$sgal({
            title: 'Não foi possível!',
            text: error.response.data.errorMessage[0],
            type: 'notification',
          });
        }
      }
    },
  },
}
</script>

<style lang="scss">
.conceitos {
  margin: 0px 15px;

  .aulas-btn-acao {
    margin: 0px;
    color: #4e4e4e!important;
  }
}
</style>
